import type { EmbarcacaoMotoresField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const MOTORES_ID = "motores";
export const MOTORES_TITLE = "Motores";
export const MOTORES_TEST_ID = "embarcacao-motores";
export const MOTORES_LOADING_MESSAGE = "Carregando os Motores da embarcação...";

/** Título do cartão quando o motor chega sem identificação, para diferenciá-lo. */
export const MOTOR_FALLBACK_LABEL = "Motor";

/** Padrão global de estado vazio do Hub para a embarcação sem motores. */
export const MOTORES_EMPTY_STATE = {
  title: "Nenhuma informação de Motores disponível",
  description: "Assim que houver dados de motor para esta embarcação, eles aparecerão nesta seção.",
};

/** Os 12 campos de cada cartão, na ordem e nas colunas do protótipo; a identificação do motor encabeça o cartão. */
export const MOTORES_FIELDS: DetailFieldDefinition<EmbarcacaoMotoresField>[] = [
  { key: "marca", label: "Marca" },
  { key: "modelo", label: "Modelo" },
  { key: "numeroSerie", label: "N° de série" },
  { key: "codigoTmMaster", label: "Código TM Master" },
  { key: "empresaAutomacaoResponsavel", label: "Empresa de automação responsável do motor" },
  { key: "potencia", label: "Potência (Kw)" },
  { key: "rpm", label: "RPM" },
  { key: "tbo", label: "TBO" },
  { key: "periodicidade", label: "Periodicidade" },
  { key: "ativo", label: "Ativo?" },
  { key: "ordemMotor", label: "Ordem Motor" },
  { key: "atualizacaoMotores", label: "Data Atualização Motores", format: formatDetailDate },
];
